/**
 * connectors-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportColumn } from './reportColumn';
import { ReportParameter } from './reportParameter';


/**
 * A saved SQL report definition.
 *
 * FIELD NAMES MATCH THE SERVER EXACTLY. They previously did not - this model declared
 * `key`, `sql` and `format` where the API has always required `templateKey`, `sqlQuery`
 * and `defaultFormat`. Jackson dropped the unknown fields, `sqlQuery` arrived null, and
 * its @NotBlank rejected the request: every create, update and validate returned 400
 * before a line of logic ran, which is why report_templates had zero rows.
 */
export interface ReportTemplate { 
    id?: number;
    templateKey?: string;
    name?: string;
    description?: string;
    sqlQuery?: string;
    /**
     * Logical datasource the SELECT runs against. Undefined/empty = the configured
     * reporting pool, which is what every template written before NUC-287 used.
     */
    datasource?: string;
    parameters?: Array<ReportParameter>;
    columns?: Array<ReportColumn>;
    defaultFormat?: ReportTemplate.FormatEnum;
    requiredCapability?: string;
    active?: boolean;
    createdBy?: string;
    createdTs?: string;
    lastModifiedBy?: string;
    lastModifiedTs?: string;
}
export namespace ReportTemplate {
    export const FormatEnum = {
        Csv: 'CSV',
        Xlsx: 'XLSX',
        Pdf: 'PDF'
    } as const;
    export type FormatEnum = typeof FormatEnum[keyof typeof FormatEnum];
}
